import { render } from "./PreviewVideo.vue?vue&type=template&id=122e7b54&scoped=true"
import script from "./PreviewVideo.vue?vue&type=script&lang=js"
export * from "./PreviewVideo.vue?vue&type=script&lang=js"

import "./PreviewVideo.vue?vue&type=style&index=0&id=122e7b54&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122e7b54"]])

export default __exports__